<script lang="ts">
	import type { Device } from 'src/types/Device.ts';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_config } from '@devices/index';
	import ControlSwitch from 'src/components/Controls/Single/ControlSwitch.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import SidepanelStatusPeek from 'src/components/Sidepanel/SidepanelStatusPeek.svelte';
	import MockDeviceChip from './MockDeviceChip.svelte';
	import { getGen1DeviceStatuses } from '../../SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import {
		peekOnlyStatusSlots,
		resolveSidepanelStatusSlots,
	} from 'src/helpers/sidepanel_status_slots';
	import { isWallDisplay } from 'src/helpers/interface_helpers';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: resolvedSlots = resolveSidepanelStatusSlots(device, _statuses);
	$: statusSlots = isWallDisplay(device?.type) ? peekOnlyStatusSlots(resolvedSlots) : resolvedSlots;
	$: showStatusPeek = !!statusSlots.main || statusSlots.peek.length > 0;
</script>

<DeviceViewStateWrapper {device} hideSlotFloatingBottom={!showStatusPeek}>
	<div slot="staticTop">
		<MockDeviceChip {device} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height align-items-center justify-content-center" slot="content">
		<ControlSwitch {device} {status} {settings} isWide />
	</div>
	<svelte:fragment slot="floatingBottom">
		{#if showStatusPeek}
			<SidepanelStatusPeek
				showMain={!isWallDisplay(device?.type)}
				main={statusSlots.main}
				peek={statusSlots.peek}
			/>
		{/if}
	</svelte:fragment>
</DeviceViewStateWrapper>
